export const GET_PACK_SITE = 'GET_PACK_SITE';
export const GET_PACK_SITE_ERROR = 'GET_PACK_SITE_ERROR';
export const NO_MORE_PACK_SITE_DETAIL = 'NO_MORE_PACK_SITE_DETAIL';
export const GET_PACK_SITE_SUCCESS = 'GET_PACK_SITE_SUCCESS';
export const POST_PACK_SITE = 'POST_PACK_SITE';
export const POST_PACK_SITE_ERROR = 'POST_PACK_SITE_ERROR';
export const POST_PACK_SITE_SUCCESS = 'POST_PACK_SITE_SUCCESS';